<template> 
    <!-- 登录后使用 申购,赎回,预约等  -->
    <section class="container-four flex ">
        <!-- 左侧导航菜单 -->
        <left-menu :menuSlt="menuSlt"/>
		<!--右侧对应菜单内容-->
		<div class="right-contnet flex-1 bg-white box-shadow posi-relative">
			<!-- 页面的名称 -->
            <page-title :pageName="pageName" :fundCode="fundCode" :styleCpt="pageStyle"/>
            <!-- 页面内容 -->
            <div class="right-contnet-box" :class="{'ie-box' : isIE}">
                <slot> </slot>
            </div>
		</div>
    </section>
</template>
<script>
    import leftMenu from '../publicCpts/leftMenu'
    export default {
        components:{leftMenu},
        mounted(){
            this.initHandle(this);
        },
        props:['menuSlt','pageName','fundCode','pageStyle'],
        data(){
            return {
                isIE:false
            }
        },
        methods:{	 
            //检查是否登录 
            checkLoginStatus(){
                //如果已经登录 (后期可能改掉,用state)
                if(this.$store.state.userInfo.username){ 
                    that.$emit('setLogin',this.$store.state.userInfo.username);
                }
            },
            //风险等级不匹配提示
            riskLevelTip(minRiskFlag,fundRiskOrUrl,riskMsg){ 
                let strTip = '',fdRiskOrUrl = fundRiskOrUrl.split(',');
                this.fundUrl = fdRiskOrUrl[2];
                //如果是C1最低
                if(minRiskFlag==10 && riskMsg.indexOf('C1') > -1){
                    strTip = '您当前风险等级为C1(风险承受能力最低类别)，属于最 低风险承受能力 的投资者，根据适当性匹配原则和相关法规要求，';
                    strTip += '仅可购买我司风险等级为R1(低风险)的产品，';
                    strTip += '无法购买风险等级为R2(中低风险)、R3(中风险)、R4(中高风险)、R5(高风险)的产品。';
                    //弹框提示
                    this.$tools.showConfirmMsg_model(strTip,'/fengxianceping','','去风险评测','放弃','风险等级不匹配提示');
                }else{
                    this.isShowfxbppjsh = true;
                    //风险不匹警示函
                    this.fxbppjshTxt = '经核实，您申请购买的产品或服务等级为'+fdRiskOrUrl[1]+'，您当前的';
                    this.fxbppjshTxt += '风险等级'+riskMsg+'，不属于最低风险承受能力的投资者，不存在违反准';
                    this.fxbppjshTxt += '入要求的情况。根据适当性匹配原则，该产品或者服务高于您风险承受能力，我司特此向您警示：购买该产品/服务，';
                    this.fxbppjshTxt += '可能导致您承担超出自身承受能力损失以及不利后果。请您认真考虑相应风险，审慎决定购买该产品或服务';
                    //投资者确认书
                    this.tzzqrsTxt = '本人已收到贵司出具的《风险不匹配警示函》，对于本人申请购买产品/服务风险等级高于本人';
                    this.tzzqrsTxt += '风险承受能力情况已知悉，并且已充分了解该产品/服务的风险特征和可能的不利后果。';
                    this.tzzqrsTxt += '经本人审慎考虑，仍坚持申请购买该产品/服务，并自愿承担由此可能产生的一切不利后果和损失。'; 
                    this.tzzqrsTxt +='该销售机构及工作人员在销售过程中，不存在直接或间接主动向本人推荐该产品/服务的行为。'
                    //弹框提示
                    //this.$tools.showConfirmMsg_model(strTip,fdRiskOrUrl[2],'','仍要继续','放弃','风险等级不匹配提示');
                }
            },
            //基金的风险等级 的判断
            fdRiskLevel(fundRiskOrUrl){   
                let riskAbility = that.$store.state.userInfo.riskAbility,riskMsg = '',that = this;
                //判断 风险等级是否过期，0没过期，1过期
                if(that.$store.state.userInfo.riskFlag != 0){
                    let strErr = '您的风险评测已过期，请尽快重新评测，以免影响您的正常交易。';
                    that.$tools.showConfirmMsg_model(strErr,'/fengxianceping',"","立刻前往",'稍后再说',"风险评测过期");
                    return;
                }
                //如果风险等级不匹配 进行提示，否则 可购买
                if( riskAbility > fundRiskOrUrl.split(',')[0] ){
                    //风险等级 大于 等于 基金的风险等级即可,并跳转至 下一页
                    that.$router.push({path:fundRiskOrUrl.split(',')[2]});
                }else{
                    // 风险费等级描述
                    riskMsg = that.$store.state.userInfo.riskAbilityDesc;	
                    // 判断是最低风险等级
                    if(that.$store.state.userInfo.minRiskFlag == 1){
                        riskMsg = 'C1(最低风险承受能力)';
                    }
                    //风险等级不匹配提示
                    that.riskLevelTip(that.$store.state.userInfo.minRiskFlag,fundRiskOrUrl,riskMsg); 
                }
            },
            //跳转至 购买或者 定投
            // 仍要继续时, 购买 和 定投 跳转
            linkToBuyOrFixed(){
                this.$router.push({path:this.fundUrl})
            },
            //页面初始化数据
            initHandle(that){
                //设置页面滚动
                that.$emit('setScroll',0);
                //检查是否登录
                that.checkLoginStatus(that); 
                that.isIE = false;
                if (!!window.ActiveXObject || "ActiveXObject" in window) { 
                    that.isIE = true;
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    section.container-four{
        width: 60rem;
        margin: 0 auto; 
        // 右侧对应菜单内容
        .right-contnet{
            min-height: 10rem;
            margin-left: 1rem;
            padding-bottom:1rem;
            // 右边内容显示
            .right-contnet-box{
                width:49.5rem;
                padding:2rem 16rem 0 3rem;
            }
            // 灰色条
            .grayBar{
                height:1rem;
                margin:0 -.5rem 0;
                background:#f7f7f7;
            }
        } 
        
    }
</style>

<style lang="less">
    section.container-four{
        // 手机验证码
        .wkInputPhoneValidate{
            .input-container{
                width: 11.5rem;;
            }
        }
        // 按钮
        .btn-box{
            padding-left:11rem;
            text-align: center;
        }
        // 条款
        .clause-box{
            display: flex;
            line-height: 1.3rem;
            padding: .5rem 0 .2rem 0;
            color:#666;
            img{
                width: 1rem;
                height: 1rem;
                margin:.25rem .5rem 0 0;
            }
        } 
        // 条款
        .wk-input-box .terms-box{
            width:18.5rem;
            margin-left:11.3rem;
            a{
                color: #123593 !important;
                cursor: pointer;
            }
        }
        // 温馨提示 (单行title)
        .reminder{
            padding:1rem 0 1rem 19rem;
            cursor: pointer;
        }
        // 温馨提示 (多行 包含title 和 内容)
        .reminder-box{
            margin:1.6rem -12rem 0 0;
            padding:.75rem 5rem;
            border-top:.05rem solid #EFEFEF ;
            .reminder-title{
                padding:.6rem 0 .5rem;
            }
            .reminder-content{
                p{
                    line-height:1.2rem;
                    color:#666;
                }
            }
        }
        .ie-box{
            .wk-input-box {
                .terms-box{
                    margin-left:0;
                }
                .btn-box{
                    padding-left:0rem;
                }
            }
           .reminder-box{
               margin-left:-12rem;
           }
        }
    }   
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/containerFour.vue